module.exports = __webpack_public_path__ + "img/iptv-flex.74267144.svg";